import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import "./Common_Call_Button.css";
import Send_Button_Modal from "../../common-modals/send-btn-modal/Send_Button_Modal";
import Call_Now_Modal from "../../common-modals/call-now-modal/Call_Now_Modal";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../utils/context";

function Common_Call_Button({
  vendor,
  onClick,
  onClick2,
  onClick3,
  onClick4,
  onClick5,
}) {
  const { signin, userdata } = useContext(Context);
  const navigate = useNavigate();
  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);
  const hasSubscription =
    userdata?.subscription_status === true &&
    Array.isArray(userdata?.user_subscription) &&
    userdata.user_subscription.length > 0;

  //   const handleCallClick = () => {
  //   if (!signin) {
  //     navigate("/login");
  //     return;
  //   }

  //   const isMobile = window.innerWidth < 991;

  //   if (isMobile) {
  //     // 👉 Open phone dialer
  //     window.location.href = `tel:${vendor?.phone || "1234567890"}`;
  //   } else {
  //     // 👉 Open modal (existing behavior)
  //     if (onClick2) onClick2();
  //   }
  // };
  const handleCallClick = () => {
    if (!signin) {
      navigate("/login");
      return;
    }

    // ✅ ALWAYS check FIRST
    if (!hasSubscription) {
      if (onClick) {
        onClick("NO_SUBSCRIPTION");
        return;
      }
    }

    const isMobile = window.innerWidth < 991;

    const phone = vendor?.phone || vendor?.user?.mobile_number || "1234567890";

    if (isMobile) {
      window.location.href = `tel:${phone}`;
    } else {
      // ✅ unified handling
      if (onClick) return onClick();
      if (onClick2) return onClick2();
      if (onClick3) return onClick3();
      if (onClick4) return onClick4();
      if (onClick5) return onClick5();
    }
  };
  // const handleCallClick = () => {
  //   if (!signin) {
  //     navigate("/login");
  //     return;
  //   }

  //   if (!hasSubscription) {
  //     onClick?.("NO_SUBSCRIPTION");
  //     return;
  //   }

  //   const isMobile = window.innerWidth < 991;

  //   // ✅ Get phone (vendor OR expert)
  //   const phone = vendor?.phone || vendor?.user?.mobile_number || "1234567890";

  //   if (isMobile) {
  //     window.location.href = `tel:${phone}`;
  //   } else {
  //     // ✅ ALWAYS call onClick FIRST
  //     if (onClick) {
  //       onClick();
  //       return;
  //     }

  //     if (onClick2) {
  //       onClick2();
  //       return;
  //     }

  //     if (onClick3) {
  //       onClick3();
  //       return;
  //     }

  //     if (onClick4) {
  //       onClick4();
  //       return;
  //     }

  //     if (onClick5) {
  //       onClick5();
  //       return;
  //     }
  //   }
  // };

  return (
    <div className="vendor-buttons">
      <Button className="call-btn" onClick={handleCallClick}>
        Call Now
      </Button>
    </div>
  );
}

export default Common_Call_Button;
